import styled from 'styled-components'
import { theme } from '../styles/GlobalStyle'

const ButtonStyle = styled.div`
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 ${theme.green};
  background-color: ${theme.green};
  padding: 10px 20px;
  color: #fff;
  font-family: Ubuntu-Medium, sans-serif;
  font-size: 16px;
  line-height: 1.51;
  letter-spacing: 1.1px;
  text-align: center;
  text-transform: uppercase;
  max-width: 240px;
  max-height: 48px;

  .btn:visited,
  .btn:hover,
  .btn:focus,
  .btn:active {
    color: #fff;
  }
`

export default ButtonStyle
